import React from 'react';

export default function IconScreener() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66545 10V13.3333C9.66545 13.7015 9.36697 14 8.99878 14H6.99878C6.63059 14 6.33211 13.7015 6.33211 13.3333V10L2.35057 5.6693C2.12433 5.42323 1.99878 5.10116 1.99878 4.76689V2.66667C1.99878 2.29848 2.29726 2 2.66545 2H13.3308C13.6995 2 13.9982 2.29929 13.9974 2.668L13.9932 4.81188C13.9925 5.14715 13.8655 5.46987 13.6376 5.71573L9.66545 10Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66536 4.66016H6.33203"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
